import { createContext, useContext } from 'react';

export type FundCarouselLayout = 'fixed' | 'auto';

const FundCarouselContext = createContext<FundCarouselLayout>('fixed');

export function useFundCarouselLayout() {
  return useContext(FundCarouselContext);
}

export default FundCarouselContext;
